/**
 * File Name          : output.model.ts
 * Author             : Jared Laine Dyreson
 * Version            : 0.0.0
 * Date               : 2026-03-18
 * Description        : Short Description (manual edit required)
 * 
 * Copyright (C) Innovative Design Labs, Inc. - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * This file is subject to the terms and conditions defined in
 * file 'IDL_BACKGROUNDTECH_LICENSE.txt', which is part of this source code package.
 */

import { DATA_TYPE } from "../data-type.model"

export class Output {
    index: number
    type: DATA_TYPE | null
    units: string | null = ""
    length: number
    name: string = ""

    constructor(index: number, type: number, length: number) {
        this.index = index
        this.type = DATA_TYPE.from(type)
        this.length = length
    }

    asObject() {
        return {
            dataCount: this.length,
            dataType: this.type,
            index: this.index,
            name: this.name
        }
    }
}

